import { useEffect, useState } from 'react';
import Mic from '../../../../Assets/StorefrontIcons/Mic.svg';
import { useSelector } from 'react-redux';
import { getPostProfile } from '../../../../lib/utils/apiCalls';

function SearchBox() {
    const [userProfile, setUserProfile] = useState({});
    const user = useSelector((state) => state.user.user);

    useEffect(() => {
        const getUserProfile = async () => {
            const profile = await getPostProfile(user.SellerUserId);
            setUserProfile(profile ? profile : {});
        }
    
        setTimeout(() => {
            Object.keys(user).length > 0 && getUserProfile();
        }, 200);
    }, [user]);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [searchBoxSize, setSearchBoxSize] = useState(0);
    const [micBoxSize, setMicBoxSize] = useState(0);
    const [iconSize, setIconSize] = useState(0);
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [textMargin, setTextMargin] = useState(0);
    const [iconMargin, setIconMargin] = useState(0);

    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setTextMargin((zoomSize/100)*19);
        setIconMargin((zoomSize/100)*3);
        setSearchBoxSize((zoomSize/100)*50);
        setMicBoxSize((zoomSize/100)*43.65);
        setIconSize((zoomSize/100)*16);
        setTextSize((zoomSize/100)*14);
        setLineHeight((zoomSize/100)*12);
        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div style={{ paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }}>
            <div 
                style={{ 
                    height: `${searchBoxSize}px`,
                    background: 'linear-gradient(135deg, #FDB62E80, #F1687880, #748BC580, #0A013080)',
                    borderRadius: '34px',
                    padding: '1px'
                }}
            >
                <div 
                    style={{ height: `${searchBoxSize - 2.25}px` }} 
                    className="bg-[#FFFFFF] rounded-[34px] flex items-center gap-[10px] select-none w-full"
                >
                    <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px`, marginLeft: `${textMargin}px` }} className='w-3/4 line-clamp-1 font-semibold text-[#B5B5B5]'>Search products from {userProfile?.name}</p>

                    <div style={{ width: `${micBoxSize}px`, height: `${micBoxSize}px`, marginRight: `${iconMargin}px`, backgroundImage: 'linear-gradient(135deg, #FFB42A, #A9D19E, #738CC5, #F17372)' }} className="rounded-full ml-auto flex items-center justify-center">
                        <div style={{ width: `${iconSize}px`, height: `${iconSize}px` }} className="flex items-center justify-center">
                            <img className='size-full' src={Mic} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SearchBox;
